export default __webpack_public_path__ + "static/media/honeyBee.b43f334a.svg";